export const CANCEL_EVENT_BOOKING_START = 'CANCEL_EVENT_BOOKING_START';

export const CANCEL_EVENT_BOOKING_SUCCESS = 'CANCEL_EVENT_BOOKING_SUCCESS';

export const CANCEL_EVENT_BOOKING_FAILED = 'CANCEL_EVENT_BOOKING_FAILED';
